module.exports = __webpack_public_path__ + "img/Eqfin.640e79c0.png";